export default __webpack_public_path__ + "static/media/map-wires.ba500950.webp";